module.exports = __webpack_public_path__ + "img/discount.43cde109.png";